module.exports = __webpack_public_path__ + "img/noor.ecad472b.jpg";